module.exports = __webpack_public_path__ + "img/file-empty.f97e0308.png";